export default __webpack_public_path__ + "static/media/thrilling_tales_of_dragon_slayers.692d45b8.png";